export const EXEMPT_ORDER_INVOICE_ID = 'EXEMPT'
